import {
  Globe2,
  Network,
  SlidersHorizontal,
  Users,
  MessageCircle,
  MonitorSmartphone,
  TrendingUp,
  LayoutTemplate,
  Megaphone,
  Headset,
  RefreshCw,
  Hotel,
  Package,
  CalendarDays,
  Zap,
  Wallet,
  BedDouble,
  Tag,
  BarChart3,
  Database,
  ClipboardList,
  PhoneCall,
  Repeat,
  MessageSquare,
  MailCheck,
  Bell,
  FileText,
  Heart,
  DoorOpen,
  User,
  Sparkles,
  CreditCard,
  Target,
  Smartphone,
  Search,
  Camera,
  Video,
  Wrench,
} from "lucide-react";

export const WHATSAPP_NUMBER = "918368808443";
export const WHATSAPP_DISPLAY = "+91 83688 08443";
export const COMPANY_EMAIL = "sales@superhostcloud.com";
export const FOOTER_EMAIL = "sales@superhostcloud.com";
export const COMPANY_CITY = "Noida";

export const WA_DEFAULT_MESSAGE = "Hi Superhost Cloud, I'd like to know more about your hotel management services.";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message || WA_DEFAULT_MESSAGE)}`;

// Format a raw whatsapp number (e.g. 918368808443) into "+91 83688 08443"
export const toIntlDigits = (raw) => {
  const d = String(raw || "").replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};

export const formatWaDisplay = (raw) => {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) return `+91 ${d.slice(2, 7)} ${d.slice(7)}`;
  if (d.length === 10) return `+91 ${d.slice(0, 5)} ${d.slice(5)}`;
  return d ? `+${d}` : WHATSAPP_DISPLAY;
};

// Structural service data (text lives in i18n translations, keyed by slug)
export const serviceList = [
  { slug: "ota-management", icon: Globe2, detail: true },
  { slug: "channel-management", icon: Network, detail: true },
  { slug: "room-pricing", icon: SlidersHorizontal, detail: true },
  { slug: "hotel-crm", icon: Users, detail: true },
  { slug: "whatsapp-automation", icon: MessageCircle, detail: true },
  { slug: "front-office", icon: MonitorSmartphone, detail: true },
  { slug: "revenue-management", icon: TrendingUp, detail: true },
  { slug: "website-development", icon: LayoutTemplate, detail: true },
  { slug: "social-media", icon: Megaphone, detail: true },
  { slug: "owner-support", icon: Headset, detail: true },
];

export const serviceDetailMeta = {
  "ota-management": {
    icon: Globe2,
    hero: "https://images.unsplash.com/photo-1758193783649-13371d7fb8dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "channel-management": {
    icon: Network,
    hero: "https://images.unsplash.com/photo-1742844552193-2fd3425cd26d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "whatsapp-automation": {
    icon: MessageCircle,
    hero: "https://images.unsplash.com/photo-1759038085950-1234ca8f5fed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "room-pricing": {
    icon: SlidersHorizontal,
    hero: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "hotel-crm": {
    icon: Users,
    hero: "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "front-office": {
    icon: MonitorSmartphone,
    hero: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "revenue-management": {
    icon: TrendingUp,
    hero: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "website-development": {
    icon: LayoutTemplate,
    hero: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "social-media": {
    icon: Megaphone,
    hero: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  "owner-support": {
    icon: Headset,
    hero: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
};

export const statsData = [
  { id: "accommodations", value: "1500+" },
  { id: "cities", value: "318+" },
  { id: "states", value: "24" },
  { id: "otas", value: "10+" },
  { id: "support", value: "24/7" },
];

export const clientLogos = [
  "Seaside Residency",
  "Hillview Inn",
  "The Courtyard",
  "Lake Palace Stays",
  "Grand Meridian",
  "Urban Nest",
  "Royal Orchid",
  "Sunset Bay",
];

export const heroImage =
  "https://images.unsplash.com/photo-1758193783649-13371d7fb8dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
export const HERO_VIDEO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_booking-boost-12/artifacts/bgnujg9q_Untitled%20design%20%2812%29%20%282%29.mp4";
export const aboutImage =
  "https://images.unsplash.com/photo-1668480441891-3744c25337a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// Real customer reviews (same in all languages). image null => monogram fallback.
export const testimonials = [
  {
    name: "Hotel Nilay",
    image: null,
    quote:
      "Before Superhost Cloud, we had low online visibility and handling bookings was messy. Superhost Cloud made everything easier — listing our hotel on the OTAs, managing our rates, and confirming bookings. Now we get regular bookings and our online presence has clearly improved. It's been a real boost for our business!",
  },
  {
    name: "The Imperial Hotel And Restaurant",
    image: null,
    quote:
      "Superhost Cloud didn't just help us with bookings — they made sure we're visible on all major OTAs with the right rates and real-time updates. Guests are booking smoothly, and the overall experience has improved a lot. It's truly been a game-changer for us!",
  },
  {
    name: "Vrrinda Home Stay",
    image: null,
    quote:
      "Earlier, we spent hours dealing with OTA issues. Since switching to Superhost Cloud, their team takes care of our OTA listings, rate management and bookings in the background. Now we focus on our guests, not escalations — total peace of mind!",
  },
  {
    name: "Hotel Indra Palace",
    image: "/reviews/photo4.png",
    quote:
      "Superhost Cloud ne hamari property ko aasani se OTAs par list kiya, bookings ko confirm karna aasaan kar diya aur rates ko sahi se manage kiya. Ab unki poori madad ki wajah se, hotel chalana kaafi aasaan ho gaya hai!",
  },
  {
    name: "Vaishnavi dham",
    image: "/reviews/photo5.png",
    quote:
      "Hamein pehle samajh nahi aata tha ki online platforms aur OTA listings ko kaise sambhalen. Superhost Cloud ne OTA management, rates aur bookings — sab kuch apne haath mein le liya. Ab hamein mil rahe hain pakke bookings, samay par payment aur shandar support. Wakai hamare liye badi madad saabit hui hai!",
  },
  {
    name: "P VEE Resorts",
    image: "/reviews/photo6.png",
    quote:
      "Ab hamari online presence behtar hui hai aur tension kam hua hai. Superhost Cloud ne OTA listing, rate management aur booking management tak har cheez mein madad ki. Hum poori tarah se santusht hain aur Superhost Cloud ko main sabhi hoteliyaron ko zaroor anushansa karta hun!",
  },
  {
    name: "Hotel Bandu",
    image: "/reviews/photo7.png",
    quote:
      "Nakli bookings badi samasya thin, lekin ab Superhost Cloud unhen chhankar keval pushti aur bhugtan wale atithi hi late hain. Saath hi, hamari OTA listings aur rates ab ek hi jagah se manage hote hain. Ab hamein milte hain bharosemand arakshan, samay par updates aur khush grahak. Yeh hamare liye ek bada badlav hai.",
  },
  {
    name: "Hotel Nilamber",
    image: "/reviews/photo8.png",
    quote:
      "Superhost Cloud hamare liye ek bharosemand sathi ki tarah hain. Ve OTA listing, arakshan, rate management aur atithi se judi sabhi jimmedariyan sambhalte hain, jisse hum apne mehmanon ki seva par poori tarah dhyan de pate hain.",
  },
];

export const statesWithCities = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Tirupati", "Kakinada", "Rajahmundry"],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat", "Tawang", "Ziro", "Bomdila"],
  "Assam": ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga", "Purnia", "Bihar Sharif"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg", "Rajnandgaon", "Jagdalpur"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Calangute"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Gandhinagar", "Junagadh"],
  "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Karnal", "Hisar", "Rohtak", "Panchkula"],
  "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala", "Kullu", "Solan", "Mandi", "Dalhousie", "Kasauli"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", "Hazaribagh", "Giridih"],
  "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi", "Belagavi", "Udupi", "Madikeri", "Hampi"],
  "Kerala": ["Kochi", "Thiruvananthapuram", "Kozhikode", "Thrissur", "Kollam", "Alappuzha", "Munnar", "Kannur"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Khajuraho", "Rewa"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane", "Kolhapur", "Lonavala"],
  "Manipur": ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Ukhrul", "Kakching"],
  "Meghalaya": ["Shillong", "Tura", "Jowai", "Nongstoin", "Cherrapunji", "Baghmara"],
  "Mizoram": ["Aizawl", "Lunglei", "Champhai", "Serchhip", "Kolasib", "Saiha"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha", "Zunheboto"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Puri", "Sambalpur", "Berhampur", "Balasore"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "Pathankot", "Hoshiarpur"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Bikaner", "Jaisalmer", "Mount Abu"],
  "Sikkim": ["Gangtok", "Namchi", "Gyalshing", "Mangan", "Pelling", "Ravangla"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Ooty", "Kanyakumari", "Vellore"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam", "Ramagundam", "Secunderabad"],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar", "Kailashahar", "Belonia", "Ambassa"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Prayagraj", "Noida", "Ghaziabad", "Meerut"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Rishikesh", "Nainital", "Mussoorie", "Haldwani", "Roorkee", "Almora"],
  "West Bengal": ["Kolkata", "Howrah", "Darjeeling", "Siliguri", "Durgapur", "Asansol", "Kharagpur"],
  "Andaman and Nicobar Islands": ["Port Blair", "Havelock", "Neil Island", "Diglipur", "Rangat"],
  "Chandigarh": ["Chandigarh", "Manimajra", "Sector 17", "Sector 22", "Sector 35"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Daman", "Diu", "Silvassa", "Amli", "Vapi"],
  "Delhi": ["New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh", "Connaught Place"],
  "Jammu and Kashmir": ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Gulmarg", "Pahalgam", "Sonamarg"],
  "Ladakh": ["Leh", "Kargil", "Nubra", "Diskit", "Zanskar"],
  "Lakshadweep": ["Kavaratti", "Agatti", "Minicoy", "Kadmat", "Bangaram"],
  "Puducherry": ["Puducherry", "Karaikal", "Yanam", "Mahe", "Ozhukarai"],
};

export const indianStates = Object.keys(statesWithCities);

// Structural icon map for rich service detail pages (text lives in i18n translations)
export const richServiceIcons = {
  "channel-management": [RefreshCw, Hotel, Package, CalendarDays, Zap, Wallet],
  "room-pricing": [BedDouble, Tag, BarChart3, Users, CalendarDays, Zap],
  "hotel-crm": [Database, ClipboardList, PhoneCall, Repeat, MessageSquare, BarChart3],
  "whatsapp-automation": [MessageSquare, MailCheck, FileText, Bell, Hotel, Users],
  "front-office": [DoorOpen, User, BedDouble, Sparkles, CalendarDays, CreditCard],
  "revenue-management": [CalendarDays, Wallet, TrendingUp, Hotel, BarChart3, Target],
  "website-development": [LayoutTemplate, Smartphone, CalendarDays, Wallet, Zap, Search],
  "social-media": [Camera, Target, Video, Megaphone, BarChart3, MessageSquare],
  "owner-support": [CalendarDays, Hotel, RefreshCw, MonitorSmartphone, Users, PhoneCall],
};

export const richServiceSlugs = Object.keys(richServiceIcons);
